export default __webpack_public_path__ + "static/media/web.88179df0.png";